// Load notification integration after initialization to avoid the GraphQL/logout cycle.
export const loadPushNotificationService = () => {
    return import('./service');
};
